<script>
    import { onMount } from "svelte";

    let copied = false;
    let codeElement;

    function copyCode() {
        if (!codeElement) return;

        const code = codeElement.textContent;
        navigator.clipboard.writeText(code).then(() => {
            copied = true;
            setTimeout(() => {
                copied = false;
            }, 2000);
        });
    }

    onMount(() => {
        // Find all pre elements and add copy buttons
        const pres = document.querySelectorAll(".blog-post__content pre");
        pres.forEach((pre) => {
            if (pre.querySelector(".copy-button")) return; // Already has button

            const button = document.createElement("button");
            button.className = "copy-button";
            button.innerHTML = `
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="5" y="5" width="9" height="9" rx="1" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M3 11V3C3 2.44772 3.44772 2 4 2H10" stroke="currentColor" stroke-width="1.5"/>
                </svg>
                <span class="copy-text">Copy</span>
                <span class="copied-text">Copied!</span>
            `;

            button.addEventListener("click", () => {
                const codeElement = pre.querySelector("code");
                const code = codeElement
                    ? codeElement.textContent
                    : pre.textContent;
                navigator.clipboard.writeText(code).then(() => {
                    button.classList.add("copied");
                    setTimeout(() => {
                        button.classList.remove("copied");
                    }, 2000);
                });
            });

            pre.appendChild(button);
        });
    });
</script>

<style>
    :global(.copy-button) {
        position: absolute;
        top: 0.75rem;
        right: 0.75rem;
        padding: 0.5rem 0.75rem;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 0.375rem;
        color: #e0e0e0;
        font-size: 0.75rem;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.35rem;
        transition: all 0.2s ease;
        backdrop-filter: blur(8px);
    }

    :global(.copy-button:hover) {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.3);
    }

    :global(.copy-button .copied-text) {
        display: none;
    }

    :global(.copy-button.copied .copy-text) {
        display: none;
    }

    :global(.copy-button.copied .copied-text) {
        display: inline;
    }

    :global(.copy-button.copied) {
        background: rgba(34, 197, 94, 0.2);
        border-color: rgba(34, 197, 94, 0.4);
        color: #86efac;
    }
</style>
